export default "https://assets.egbcdn.net/assets/packs/_/images/referrals/icon-phone-288efe28b318b2d7f842e9516d9d4fab.png";